module.exports = __webpack_public_path__ + "img/53n.6a3e9898.png";